'use client'
import { useState } from 'react'

import { useRouter } from 'next/navigation'

import { AuthenticationAPI } from '../../../data/authentication'

import CardDefault from '../cards/CardDefault'
import InputDefault from '../forms/InputDefault'
import { COUNTRY_UAE_ID, isDev } from '../../../data/constants'
import { Route } from '../../../routers/routes'
import ButtonWSpinner from '../buttons/ButtonWSpinner'

export default function UserCreateForm(props) {
  const {
    countryId = COUNTRY_UAE_ID,
    onSuccess,
  } = props

  let formDataPayload = {}
  if (isDev) {
    formDataPayload = {
      username: 'hasselito',
      first_name: 'Hassan',
      last_name: 'Mian',
      email: 'mian@willandskill.se',
      password_1: 'MystikaL!2k12',
      password_2: 'MystikaL!2k12',
    }
  }
  const [formData, setFormData] = useState(formDataPayload)
  const [errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const router = useRouter()

  const handleOnChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleOnFormSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    const { data, response } = await AuthenticationAPI.createUser(formData)

    setIsLoading(false)
    if (response.ok) {
      if(onSuccess) {
        onSuccess()
      } else {
        router.push(Route.login())
      }
    } else {
      setErrors(data)
    }
  }
  return (
    <>
      <CardDefault>
        <p className="mb-4">Enter your information to create an account</p>
        <form onSubmit={handleOnFormSubmit}>
          <InputDefault
            name="username" type="text" label="Username"
            placeholder="Enter your username"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="first_name" type="text" label="First Name"
            placeholder="Enter your first name"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="last_name" type="text" label="Last Name"
            placeholder="Enter your last name"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="email" type="email" label="Email"
            placeholder="Enter your email"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="password_1" type="password" label="Password"
            placeholder="Enter your password"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          <InputDefault
            name="password_2" type="password" label="Confirm Password"
            placeholder="Please confirm your passwod"
            formData={formData} errors={errors}
            onChange={handleOnChange}
          />
          {errors.non_field_errors && errors.non_field_errors.map((error, index) => {
            return <p key={index} className="text-danger">{error}</p>

          })}
          <ButtonWSpinner
            type="submit"
            className="w-full"
            isLoading={isLoading}
            label="Create Account"
          />
        </form>
        {/* <p className="mt-4">
          Already have an account? <Link className="underline" href={Route.login()}>Click here to login</Link>
        </p> */}
      </CardDefault>
    </>
  )
}
